import React, { useState, useEffect } from 'react';
import LoadingProgressIcon from './LoadingProgressIcon';
import { makeStyles } from '../styles';
const useStyles = makeStyles(({ palette }) => ({
    progressBar: {
        '&[value]': {
            height: '5px',
            verticalAlign: 'middle',
        },
        '&[value]::-webkit-progress-value': {
            backgroundImage: `linear-gradient(-88deg, #00ceb3 0%, ${palette.secondary.main} 100%)`,
        },
        '&:-webkit-appearance': 'none',
        appearance: 'none',
        '&:-webkit-progress-value': {
            backgroundColor: palette.secondary.main,
        },
        '&:-webkit-progress-bar': {
            backgroundColor: '#eee',
            borderRadius: 2,
            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.25) inset',
        },
    },
}));
function LoadingProgress() {
    const MAX_VALUE = 300;
    const classes = useStyles({ width: MAX_VALUE });
    const [value, setValue] = useState(1);
    const [direction, setDirection] = useState(true);
    useEffect(() => {
        const tractorDirection = setTimeout(() => {
            if (value === MAX_VALUE) {
                setDirection(false);
            }
            if (value === 0) {
                setDirection(true);
            }
        }, 20);
        return () => clearTimeout(tractorDirection);
    }, [value]);
    useEffect(() => {
        const tractorMove = setTimeout(() => {
            if (direction) {
                setValue(value + 1);
            }
            else {
                setValue(value - 1);
            }
        }, 20);
        return () => clearTimeout(tractorMove);
    }, [direction, value]);
    return (React.createElement("div", { style: {
            marginTop: 50,
            width: MAX_VALUE,
            position: 'relative',
        } },
        React.createElement(LoadingProgressIcon, { style: {
                position: 'absolute',
                top: -16,
                left: `${value - 32}px`,
                width: 64,
                height: 24,
                transform: !direction && 'scaleX(-1)',
            } }),
        React.createElement("progress", { className: classes.progressBar, max: MAX_VALUE, value: value, style: { width: MAX_VALUE } })));
}
export default LoadingProgress;
//# sourceMappingURL=LoadingProgress.js.map